import React from 'react';
import { Box } from '@mui/material';

// Horizontal flex row of StatUnit cards (16px gaps).
// On viewports < 768px, switches to a 2-column grid.
export default function StatRow({ children, sx = {} }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        mb: 3,
        '@media (max-width: 767.95px)': {
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
